import { c as _c } from "react/compiler-runtime";
export const StarIcon = t0 => {
  const $ = _c(7);
  const {
    selected
  } = t0;
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.5" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = selected ? "#EFFCF8" : "#008254";
  let t4;
  if ($[2] !== t3) {
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M20.5015 24.3758L25.0898 27.1509L23.8741 21.9344L27.932 18.4183L22.5915 17.9649L20.4996 13.0285L18.4077 17.9539L13.068 18.4072L17.1259 21.9233L15.9097 27.142L20.5015 24.3758ZM25.8836 27.631C25.8834 27.6309 25.8839 27.6312 25.8836 27.631V27.631ZM20.5 26.1279L25.1074 28.9145C25.9511 29.4252 26.9836 28.6703 26.7616 27.7155L25.5403 22.4753L29.6148 18.9449C30.3586 18.3009 29.959 17.0797 28.982 17.002L23.6197 16.5468L21.5214 11.5953C21.1439 10.696 19.8561 10.696 19.4786 11.5953L17.3803 16.5357L12.018 16.9909C11.041 17.0686 10.6414 18.2898 11.3852 18.9338L15.4597 22.4642L14.2384 27.7044C14.0164 28.6592 15.0489 29.4141 15.8926 28.9034L20.5 26.1279Z" fill={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t4}</svg>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};